export default "__VITE_ASSET__BlpYPYJl__"